import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { HiArrowLongRight } from "react-icons/hi2";
import { IoMdClose } from "react-icons/io";
import { axios } from "../../../../Global";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";

export default function ContractFileUpload({
  showPromptElement,
  setShowPromptElement,
  updateComponent,
  start_date = "",
  end_date = "",
  original_term = "",
  contractDetails,
}) {
  const formatDate = (date) => {
    return date && String(date).split("-").reverse().join("-");
  };
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileDescription, setFileDescription] = useState("");
  const [fileUPloadDate, setFileUploadDate] = useState("");
  const [file, setFile] = useState();
  const [fileType, setFileType] = useState(showPromptElement?.type);
  const [startDate, setStartDate] = useState(formatDate(start_date));
  const [endDate, setEndDate] = useState(formatDate(end_date));
  const [term, setTerm] = useState(original_term);
  const fileTypes = [
    "CONTRACT FILE",
    "ANNEXURE FILE",
    "COC FILE",
    "ORGINAL DOC",
    "OTHERS",
  ];

  const reverseDate = (date) => {
    if (date) {
      return date.toString().split("-").reverse().join("-");
    } else {
      return "";
    }
  };
  const [buttonStatus, SetButtonStatus] = useState(false);

  const submitHandler = async (e, fileData) => {
    e.preventDefault();
    setLoading(true);
    SetButtonStatus(true);
    try {
      const formData = new FormData();
      formData.append("file_name", fileName?.toUpperCase());
      formData.append("type", fileType?.toUpperCase());
      formData.append("description", fileDescription?.toUpperCase());
      // formData.append("date", fileUPloadDate);
      // if (fileType === "Contract File") {
      //   formData.append("start_date", formatDate(startDate));
      //   formData.append("end_date", formatDate(endDate));
      //   formData.append("term", Number(term));
      // }
      const NodeToken = localStorage.getItem("nodeToken");

      if (fileData) {
        formData.append("file", fileData);

        const response = await nodeinstance.post(
          `/dashboard/contract/file-upload/${contractDetails?.contract?.id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${NodeToken}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response.status === 200) {
          //Update first table select input
          SetButtonStatus(false);
          if (
            [
              "CONTRACT FILE",
              "ANNEXURE FILE",
              "COC FILE",
              "ORGINAL DOC",
            ].includes(response?.data?.data?.type)
          ) {
            const body = {};
            switch (response?.data?.data?.type) {
              case "CONTRACT FILE":
                body.contract_status = "SIGNED";
                break;
              case "ANNEXURE FILE":
                body.annexure_status = "SIGNED";
                break;
              case "COC FILE":
                body.coc_attestation = "YES";
                break;
              case "ORGINAL DOC":
                body.orginal_received = "YES";
                break;
            }

            console.log(body, "body");
            try {
              const response = await axios.put(
                `/dashboard/contract/${contractDetails?.contract?.id}`,
                body,
                { headers: { Authorization: `Bearer ${token}` } }
              );
              // if (response.status === 200) {
              //   dispatch(
              //     setAppError({
              //       msg: response?.data?.message,
              //       color: "success",
              //     })
              //   );
              // }
            } catch (err) {
              // dispatch(
              //   setAppError({
              //     msg: err.response?.data?.message || "Something went wrong!",
              //   })
              // );
            }
          }
          setShowPromptElement((p) => ({ ...p, open: false }));
          updateComponent((p) => !p);
          setLoading(false);
          SetButtonStatus(false);
          dispatch(
            setAppError({
              msg: "Successfully uploaded.",
              color: "success",
            })
          );
        }
      }
    } catch (err) {
      console.log("error to be seen in console", err);

      setShowPromptElement((p) => ({ ...p, open: false }));
      updateComponent((p) => !p);
      SetButtonStatus(false);
      setLoading(false);
      if (err.message === "Request failed with status code 604") {
        dispatch(
          setAppError({
            msg: "File size exceeds......",
          })
        );
      } else {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }

      // if (err.response?.data?.message) {
      //   dispatch(
      //     setAppError({
      //       msg: err.response?.data?.message,
      //     })
      //   );
      // }
    }
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen py-10 bg-black/50  justify-center items-center ${
        showPromptElement.open ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-xl w-full max-h-[35rem] h-full  rounded-md bg-white/95 flex  flex-col p-4 relative overflow-y-scroll">
        <center>
          <div className="max-w-lg lg:max-w-5xl w-full bg-white dark:bg-dark rounded-md  p-5 flex flex-col  items-start justify-center">
            <div className="flex justify-between items-center w-full mb-2">
              <h2 className="text-2xl  font-bold ">File Upload</h2>
              <IoMdClose
                size={"1.4rem"}
                onClick={() => {
                  setShowPromptElement((p) => ({ ...p, open: false }));
                }}
                className="cursor-pointer"
              />
            </div>
            <form onSubmit={(e) => submitHandler(e, file)} className="w-full">
              <div className="w-full flex flex-col justify-center items-center ">
                <div className="form-control w-full">
                  <label className="label">
                    <span className="label-text">File Name</span>
                  </label>
                  <input
                    type="text"
                    placeholder="ENTER FILE NAME"
                    className="input input-bordered w-full "
                    defaultValue={fileName}
                    onChange={(e) => setFileName(e.target.value)}
                    required
                  />
                </div>
                <div className="form-control w-full ">
                  <label className="label">
                    <span className="label-text">File Description</span>
                  </label>
                  <textarea
                    rows={2}
                    type="text"
                    placeholder="ENTER FILE DESCRIPTION"
                    className="textarea textarea-bordered w-full "
                    defaultValue={fileDescription}
                    onChange={(e) => setFileDescription(e.target.value)}
                    required
                  />
                </div>
                {/* <div className="form-control w-full ">
                  <label className="label">
                    <span className="label-text">Date</span>
                  </label>
                  <input
                    type="date"
                    placeholder="Type here"
                    className="input input-bordered w-full "
                    value={reverseDate(fileUPloadDate)}
                    onChange={(e) =>
                      setFileUploadDate(reverseDate(e.target.value))
                    }
                    required
                  />
                </div> */}
                <div className="form-control w-full ">
                  <label className="label">
                    <span className="label-text">Select File Type</span>
                  </label>
                  <select
                    className="select select-bordered"
                    defaultValue={showPromptElement?.type}
                    onChange={(e) => setFileType(e.target.value)}
                    required
                  >
                    <option value={""} hidden>
                      Select File Type
                    </option>
                    {fileTypes.map((type, i) => (
                      <option key={i} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </div>
                {/* {fileType === "Contract File" && (
                  <>
                    <div className="form-control w-full ">
                      <label className="label">
                        <span className="label-text">Start Date</span>
                      </label>
                      <input
                        type="date"
                        className="input input-bordered w-full "
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-control w-full ">
                      <label className="label">
                        <span className="label-text">End Date</span>
                      </label>
                      <input
                        type="date"
                        placeholder="Type here"
                        className="input input-bordered w-full "
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-control w-full ">
                      <label className="label">
                        <span className="label-text">Term</span>
                      </label>
                      <input
                        type="number"
                        placeholder="Type here"
                        className="input input-bordered w-full "
                        value={term}
                        onChange={(e) => setTerm(e.target.value)}
                        required
                      />
                    </div>
                  </>
                )} */}
                <div className="form-control w-full ">
                  <label className="label">
                    <span className="label-text">Upload File</span>
                  </label>
                  <input
                    type="file"
                    className="file-input file-input-bordered w-full "
                    onChange={(e) => setFile(e.target.files[0])}
                    required
                    accept="image/*, application/doc, application/docx, application/pdf, application/xls, application/xlsx"
                  />
                </div>
                <button
                  type="submit"
                  className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                  disabled={buttonStatus}
                >
                  {" "}
                  <p>Submit</p>
                  {loading ? (
                    <CgSpinner className="animate-spin" />
                  ) : (
                    <HiArrowLongRight size={"1.2rem"} />
                  )}
                </button>
              </div>
            </form>
          </div>
        </center>
      </div>
    </div>
  );
}
